<!-- Keyboard and switch-access controls for the round. Visually hidden until
     focused, so a keyboard user tabbing into the canvas finds real buttons with
     real names, and a pointer user never sees them. -->
<template>
  <div class="junction-buttons" role="group" aria-label="Round controls">
    <button type="button" @click="$emit('switch')">Switch next junction</button>
    <button type="button" :disabled="!canRelease" @click="$emit('release')">Release</button>
    <button type="button" :disabled="!canBurst" @click="$emit('burst')">Burst</button>
  </div>
</template>

<script setup>
defineProps({
  canRelease: { type: Boolean, default: false },
  canBurst: { type: Boolean, default: false },
});
defineEmits(['switch', 'release', 'burst']);
</script>
